import React from "react";
import Checkbox from "../../common/Checkbox";
import "./style.css";

const S = {};

// ---------------------------
// General
// ---------------------------

S.Grid = ({ children, style, ...rest }) => (
  <div className="grid" {...rest}>
    {children}
  </div>
);

S.GridRow = ({ children, className = "", ...rest }) => (
  <div
    className={`grid-row ${className}`}
    style={{
      height: rest.stretch ? "100%" : "auto",
      flex: rest.stretch ? "auto" : "none",
    }}
    {...rest}
  >
    {children}
  </div>
);

S.GridCell = ({ children, stretch, style = {}, ...rest }) => (
  <div
    className="grid-cell"
    style={{ flex: stretch ? "1" : "none", ...style }}
    {...rest}
  >
    {children}
  </div>
);

S.PanelStack = ({ children, ...rest }) => (
  <div className="panel-stack" {...rest}>
    {children}
  </div>
);
S.PanelStackHeader = ({ children, className = "", ...rest }) => (
  <div className={`panel-stack-header ${className}`} {...rest}>
    {children}
  </div>
);

// S.PanelStackButton = styled.button`
//   border: none;
//   border-radius: 4px 4px 0 0;
//   height: 100%;
//   box-sizing: border-box;
//   vertical-align: middle;
//   border: ${props => props.active ? '1px rgb(220, 220, 220) solid' : '1px transparent solid'};
//   border-bottom: none;
//   font-size: 12px;
//   font-weight: 500;
//   position: relative;
//   background: ${props => props.active ? 'rgb(255, 255, 255)' : 'none'};
//   z-index: ${props => props.active ? '4' : '0'};
//   cursor: pointer;

//   :after {
//     position: absolute;
//     content: '';
//     bottom: -1px;
//     height: 1px;
//     left: 0;
//     width: 100%;
//     background: rgb(255, 255, 255);
//     display: ${props => props.active ? 'block' : 'none'}
//   }

//   :focus {
//     outline:0;
//   }
// `;
S.PanelStackButton = ({ children, ...rest }) => (
  <button
    className="panel-stack-button"
    style={{
      border: rest.active
        ? "1px rgb(161, 161, 161) solid"
        : "1px rgb(238, 238, 238) solid",
      background: rest.active ? "rgb(255, 255, 255)" : "none",
      zIndex: rest.active ? "4" : "0",
      color: rest.active ? "black" : "rgb(103, 119, 145)",
      fontSize: "11px",
    }}
    {...rest}
  >
    {children}
  </button>
);

S.Panel = ({ children, ...rest }) => (
  <div className="panel" {...rest}>
    {children}
  </div>
);

S.PanelHeader = ({ children, ...rest }) => (
  <div className="panel-header" {...rest}>
    {children}
  </div>
);

S.PanelBody = ({ children, ...rest }) => (
  <div className="panel-body" {...rest}>
    {children}
  </div>
);

S.PanelFooter = ({ children, ...rest }) => (
  <div className="panel-footer" {...rest}>
    {children}
  </div>
);

S.Header = ({ children, ...rest }) => (
  <div className="header" {...rest}>
    {children}
  </div>
);
//
//
//
S.PlayerHeader = ({ children, ...rest }) => (
  <div className="player-header" {...rest}>
    {children}
  </div>
);

// ---------------------------
// CategoryTable
// ---------------------------

S.Categories = ({ children, ...rest }) => (
  <div className="categories" {...rest}>
    {children}
  </div>
);

S.CategoriesTable = ({ children, ...rest }) => (
  <table className="categories-table" {...rest}>
    {children}
  </table>
);

// ---------------------------
// Field
// ---------------------------

S.Fields = ({ children, ...rest }) => (
  <div className="fields" {...rest}>
    {children}
  </div>
);

S.Field = ({ children, ...rest }) => (
  <div className="field" {...rest}>
    {children}
  </div>
);

S.FieldTitle = ({ children, ...rest }) => (
  <div className="field-title" {...rest}>
    {children}
  </div>
);

S.FieldBadge = ({ children, ...rest }) => (
  <div className="field-badge" {...rest}>
    {children}
  </div>
);

S.FieldValue = ({ children, ...rest }) => (
  <div className="field-value" {...rest}>
    {children}
  </div>
);

// ---------------------------
// Timeline
// ---------------------------

S.Timeline = ({ children, ...rest }) => (
  <div className="timeline" {...rest}>
    {children}
  </div>
);

S.TimelineBody = ({ children, ...rest }) => (
  <table className="timeline-body" {...rest}>
    {children}
  </table>
);

S.TimelinePlayhead = ({ children, isSentimentAnalyzerOn, ...rest }) => (
  <svg
    className="timeline-play-head"
    style={{
      pointerEvents: isSentimentAnalyzerOn ? "none" : "visible",
      cursor: isSentimentAnalyzerOn ? "auto" : "pointer",
    }}
    {...rest}
  >
    {children}
  </svg>
);

S.TrackGroup = ({ children, ...rest }) => (
  <tbody className="track-group" {...rest}>
    {children}
  </tbody>
);

S.TrackGroupLabel = ({ children, ...rest }) => (
  <th className="track-group" {...rest}>
    {children}
  </th>
);

S.Track = ({ children, ...rest }) => (
  <tr className="track" {...rest}>
    {children}
  </tr>
);

S.TrackLabel = ({ children, ...rest }) => (
  <td className="track-label" {...rest}>
    {children}
  </td>
);

S.TrackContent = ({ children, ...rest }) => (
  <td className="track-content" {...rest}>
    {children}
  </td>
);

// ---------------------------
// Controls
// ---------------------------

S.Controls = ({ children, ...rest }) => (
  <div className="control" {...rest}>
    {children}
  </div>
);

S.ControlsHeader = ({ children, ...rest }) => (
  <div className="control-header" {...rest}>
    {children}
  </div>
);

S.ControlsBar = ({ children, ...rest }) => (
  <div className="control-bar" {...rest}>
    {children}
  </div>
);

S.ControlsGroup = ({ children, ...rest }) => (
  <div className="control-group" {...rest}>
    {children}
  </div>
);

S.PrimaryControls = ({ children, ...rest }) => (
  <div className="primary-control" {...rest}>
    {children}
  </div>
);

S.VolumeControls = ({ children, ...rest }) => (
  <div className="volume-control" {...rest}>
    {children}
  </div>
);
S.MoreDetailTooltipContent = ({ children, ...rest }) => (
  <div className="more-detail-tooltip-content" {...rest}>
    {children}
  </div>
);

// ---------------------------
// Progress
// ---------------------------
S.Progress = ({ children, ...rest }) => (
  <div className="progress" {...rest}>
    {children}
  </div>
);

S.ProgressSlider = ({ children, ...rest }) => (
  <div className="progress-slider" {...rest}>
    {children}
  </div>
);

S.ProgressTime = ({ children, ...rest }) => (
  <div className="progress-time" {...rest}>
    {children}
  </div>
);

S.ProgressMark = ({ children, ...rest }) => (
  <div className="progress-mask" {...rest}>
    {children}
  </div>
);

S.ProgressContent = ({ children, ...rest }) => (
  <div className="progress-content" {...rest}>
    {children}
  </div>
);

S.ProgressHeader = ({ children, ...rest }) => (
  <div className="progress-header" {...rest}>
    {children}
  </div>
);

S.ProgressLabel = ({ children, ...rest }) => (
  <div className="progress-label" {...rest}>
    {children}
  </div>
);

S.ProgressEventMark = ({ children, ...rest }) => (
  <div className="progress-label-mark" {...rest}>
    {children}
  </div>
);
S.ProgressControl = ({ children, ...rest }) => (
  <div className="progress-control" {...rest}>
    {children}
  </div>
);
S.ProgressIcon = ({ children, ...rest }) => (
  <div className="progress-icon" {...rest}>
    {children}
  </div>
);
S.ProgressIconStyle = ({ children, ...rest }) => (
  <div className="progress-icon-style" {...rest}>
    {children}
  </div>
);
S.ProgressSpeed = ({ children, ...rest }) => (
  <div className="progress-speed" {...rest}>
    {children}
  </div>
);
S.ProgressSpeedText = ({ children, ...rest }) => (
  <div className="progress-speed-text" {...rest}>
    {children}
  </div>
);
S.ProgressSpeedButton = ({ children, active, ...rest }) => (
  <button
    className={`progress-speed-text-button ${
      active ? "progress-speed-text-button-active" : ""
    }`}
    {...rest}
  >
    {children}
  </button>
);
// ---------------------------
// Transcript
// ---------------------------
// S.Transcript = styled.article`
//   font-family: ${DEFAULT_FONT};
//   font-size: 14px;
//   line-height: 1.5;
//   padding: 4px;
//   overflow-y: scroll;
//   flex: 1;
// `;

S.Transcript = ({ children, ...rest }) => (
  <article ref={rest.ref} className="transcript-data" {...rest}>
    {children}
  </article>
);

S.TranscriptBody = ({ children, isChatTextMedia, ...rest }) => (
  <div className="transcript-body" {...rest}>
    {children}
  </div>
);
S.TranscriptWord = ({ children, ...rest }) => (
  <span className="transcript-word" {...rest}>
    {children}
  </span>
);
S.TranscriptTitle = ({ children, ...rest }) => (
  <div className="transcript-tile" {...rest}>
    {children}
  </div>
);

// old

S.TranscriptTurn = ({ children, className, ...rest }) => (
  <div
    className={`transcript-turn ${className}`}
    style={{ marginLeft: ({ marginOffset }) => (marginOffset ? 0 : 0) }}
    {...rest}
  >
    {children}
  </div>
);

S.TurnBody = ({ children, ...rest }) => (
  <div className="turn-body" {...rest}>
    {children}
  </div>
);

S.TurnHeader = ({ children, ...rest }) => (
  <div className="turn-header" {...rest}>
    {children}
  </div>
);

S.TurnLabels = ({ children, ...rest }) => (
  <div className="turn-labels" {...rest}>
    {children}
  </div>
);

S.TurnTime = ({ children, ...rest }) => (
  <div className="turn-time" {...rest}>
    {children}
  </div>
);

S.TimeLink = ({ children, ...rest }) => (
  <a className="time-link" {...rest}>
    {children}
  </a>
);

S.TurnSpeaker = ({ children, ...rest }) => (
  <a className="turn-speaker-text" style={{ color: rest.color }} {...rest}>
    {children}
  </a>
);

S.SentenceMarker = ({ children, className, ...rest }) => (
  <span className={`turn-speaker ${className}`} {...rest}>
    {children}
  </span>
);
S.TurnSpeakerIcon = ({ children, ...rest }) => (
  <div className="turn-speaker-icon" {...rest}>
    {children}
  </div>
);
// ---------------------------
// Categories
// ---------------------------
S.Category = ({ children, ...rest }) => (
  <div className="turn-speaker" {...rest}>
    {children}
  </div>
);

S.CategoryIcon = ({ children, ...rest }) => (
  <div
    className="category-icon"
    style={{ background: (props) => (props.active ? "#0079C0" : "none") }}
    {...rest}
  >
    {children}
  </div>
);

S.CategoryLabel = ({ children, ...rest }) => (
  <div className="category-label" {...rest}>
    {children}
  </div>
);

S.CategoryPill = ({ children, ...rest }) => (
  <div
    className="category-pill"
    style={{
      background: rest.active ? "#0079C0" : "#fff",
      border: rest.active ? "1px #0079C0 solid" : "1px #0079C0 dashed",
      color: rest.active ? "#fff" : "#0079C0",
    }}
    {...rest}
  >
    {children}
  </div>
);

// ---------------------------
// Metrics
// ---------------------------

// ---------------------------
// List
// ---------------------------

S.List = ({ children, ...rest }) => (
  <div className="list" {...rest}>
    {children}
  </div>
);

S.ListSectionContent = ({ children, ...rest }) => (
  <div className="list-selection-content" {...rest}>
    {children}
  </div>
);

S.ListSectionTitle = ({ children, ...rest }) => (
  <div className="list-selection-title" {...rest}>
    {children}
  </div>
);

S.ListSectionNoData = ({ children, ...rest }) => (
  <div className="list-selection-no-data" {...rest}>
    {children}
  </div>
);

S.ListSectionIcon = ({ children, ...rest }) => (
  <div className="list-selection-icon" {...rest}>
    {children}
  </div>
);

S.ListGroupHeader = ({ children, ...rest }) => (
  <div className="list-group-header" {...rest}>
    {children}
  </div>
);

S.ListGroupTitle = ({ children, ...rest }) => (
  <span className="list-group-title" {...rest}>
    {children}
  </span>
);

S.ListGroupMarker = ({ children, ...rest }) => (
  <div
    className="list-group-marker"
    style={{ visibility: (props) => (props.hide ? "hidden" : "visible") }}
    {...rest}
  >
    {children}
  </div>
);

S.ListGroupMark = ({ children, ...rest }) => (
  <div className="list-group-mark" {...rest}>
    {children}
  </div>
);

S.ListGroupBody = ({ children, collapsed, ...rest }) => (
  <div className="list-group-body" {...rest}>
    {!collapsed && children}
  </div>
);

S.ListItem = ({ children, ...rest }) => (
  <div className="list-item" {...rest}>
    {children}
  </div>
);
S.ListItemContent = ({ children, ...rest }) => (
  <div
    className="list-item-content"
    style={{
      //   background: rest.selected && "rgba(93, 44, 143, 0.2)",
      color: rest.selected && "#339EEC",
      fontWeight: rest.selected && "500",
    }}
    {...rest}
  >
    {children}
  </div>
);

S.ListItemExtra = ({ children, ...rest }) => (
  <div className="list-item-extra" {...rest}>
    {children}
  </div>
);

S.ListItemTitle = ({ children, ...rest }) => (
  <div
    className="list-item-title-container"
    style={{
      color: rest.selected ? "#339EEC !important" : "#677791",
    }}
    {...rest}
  >
    {children}
  </div>
);

S.ListItemBadge = ({ children, ...rest }) => (
  <div className="list-item-badge" {...rest}>
    {children}
  </div>
);

S.ListGroup = ({ children, ...rest }) => (
  <div className="list-group" {...rest}>
    {children}
  </div>
);

S.ListCheckbox = ({ children, ...rest }) => (
  <Checkbox className="list-checkbox" {...rest}>
    {children}
  </Checkbox>
);

S.TooltipContent = ({ children, ...rest }) => (
  <div className="tooltip-content" {...rest}>
    {children}
  </div>
);

S.SentimentButton = ({ children, ...rest }) => (
  <span className="sentiment-button" {...rest}>
    {children}
  </span>
);

S.FlagCallContent = ({ children, ...rest }) => (
  <div className="flag-call" {...rest}>
    {children}
  </div>
);

S.FlagCallImage = ({ children, ...rest }) => (
  <div className="flag-call-image" {...rest}>
    {children}
  </div>
);

S.FlagCallText = ({ children, ...rest }) => (
  <div className="flag-call-text" {...rest}>
    {children}
  </div>
);

S.FlagCallButton = ({ children, ...rest }) => (
  <button className="flag-call-button" size="sm" {...rest}>
    {children}
  </button>
);

S.FlagCallButtonContent = ({ children, ...rest }) => (
  <div className="flag-call-button-content" {...rest}>
    {children}
  </div>
);
S.PrimaryControlTitle = ({ children, ...rest }) => (
  <div className="primary-control-title" {...rest}>
    {children}
  </div>
);
S.PrimaryControlSubTitle = ({ children, ...rest }) => (
  <div className="primary-control-sub-title" {...rest}>
    {children}
  </div>
);
S.ContentTitle = ({ children, ...rest }) => (
  <div className="flag-title" {...rest}>
    {children}
  </div>
);
S.MinimizeContent = ({ children, ...rest }) => (
  <div className="minimize-content" {...rest}>
    {children}
  </div>
);

S.MiniPlayerContainer = ({ children, ...rest }) => (
  <div className="mini-player-container" {...rest}>
    {children}
  </div>
);
S.MiniPlayerBody = ({ children, ...rest }) => (
  <div className="mini-player-body" {...rest}>
    {children}
  </div>
);
S.MiniPlayerControlBar = ({ children, ...rest }) => (
  <div className="mini-player-control-bar" {...rest}>
    {children}
  </div>
);
S.SearchContainer = ({ children, ...rest }) => (
  <div className="search-container" {...rest}>
    {children}
  </div>
);
S.SearchInput = ({ children, ...rest }) => (
  <input className="search-input" type="text" {...rest}>
    {children}
  </input>
);

export default S;
